<template>
  <!-- Wrapper: choose which view to render based on session.kpi.kpiType -->
  <component
    :is="currentComponent"
    :mfConfig="mfConfig"
    :realm="realm"
  />
</template>

<script>
import Automatic from "@/views/Automatic.vue";
import Manual from "@/views/Manual.vue";

export default {
  name: "demf-kpim-editor-definition",
  props: ["mfConfig", "realm"],
  components: { Automatic, Manual },
  computed: {
    // Return the component object (Automatic or Manual) depending on session.kpi.kpiType
    currentComponent() {
      try {
        const raw = sessionStorage.getItem("kpi");
        if (!raw) return Automatic;
        const kpi = JSON.parse(raw);
        const type = ((kpi && (kpi.kpiType || kpi.type)) || "").toString();
        // Accept different casings / common labels
        if (/auto/i.test(type)) return Automatic;
        if (/manu/i.test(type)) return Manual;
        // default to Manual when unknown
        return Automatic;
      } catch (e) {
        console.warn("Failed to read session kpiType, defaulting to Automatic", e);
        return Automatic;
      }
    },
  },
};
</script>

<style scoped>
/* no styles in wrapper */
</style>
